import type { DesktopAppPlatform } from '@frameio/utils/browser';
import driveAppIcon from './driveAppIcon.png';

const DRIVE_APP_BASE_URL = 'https://drive.frame.io/latest/downloads';

export const DRIVE_APP_DOWNLOAD_URLS = {
  macArm: `${DRIVE_APP_BASE_URL}/darwin/arm64/Frame.io%20Drive.pkg`,
  macX64: `${DRIVE_APP_BASE_URL}/darwin/x64/Frame.io%20Drive.pkg`,
  windows: `${DRIVE_APP_BASE_URL}/win32/x64/Frame.io%20Drive.exe`,
};

export const getDriveAppDownloadUrl = (platform: DesktopAppPlatform) => {
  switch (platform) {
    case 'windows':
      return DRIVE_APP_DOWNLOAD_URLS.windows;
    case 'mac-x64':
      return DRIVE_APP_DOWNLOAD_URLS.macX64;
    default:
      return DRIVE_APP_DOWNLOAD_URLS.macArm;
  }
};

/**
 * Lookback window (in days) for Mounted Storage activity: recent user counts,
 * the Mounted Users list, and the copy describing them. Passed to GraphQL as
 * `$mountedStorageActivityDays`; the API accepts 1–30.
 */
export const MOUNTED_STORAGE_ACTIVITY_WINDOW_DAYS = 14;

export const MOUNTED_STORAGE_HELP_URL =
  'https://help.frame.io/en/collections/19629142-frame-io-drive-mounted-storage';

export const DRIVE_APP_ICON_SRC: string =
  typeof driveAppIcon === 'string' ? driveAppIcon : driveAppIcon?.src;
